import React, { useEffect, useState } from "react";
import { Button, Input, message, Space, Row, Col } from "antd";
import { EditOutlined, PlusOutlined, DeleteOutlined, SearchOutlined } from "@ant-design/icons";
import BrandDrawer from "./BrandsDrawer";
import API from "../../api";
import CustomTable from "../../components/Table/CustomTable";
import ConfirmationModal from "../../components/ConfirmationModal";
import { getUserRole } from "../../utils/auth";


export default function Brands() {
  const [openDrawer, setOpenDrawer] = useState(false);
  const [brands, setBrands] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [brandToDelete, setBrandToDelete] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [paginationInfo, setPaginationInfo] = useState({
    current: 1,
    pageSize: 20,
    total: 0,
  });
  const [loading, setLoading] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
    const [userRole, setUserRole] = useState("");
      
    
          useEffect(() => {
            setUserRole(getUserRole()); 
          }, []);

  // Fetch brands with updated pagination
  const fetchBrands = async () => {
    try {
      setLoading(true)
      const { current, pageSize } = paginationInfo;
      const response = await API.get("/brands/paginate", { params: { page: current, limit: pageSize, search: searchQuery, } });
      const { brands: fetchedBrands, pagination } = response.data;

      setBrands(fetchedBrands);
      setPaginationInfo((prev) => ({
        ...prev,
        total: pagination.total,
      }));
    } catch (error) {
      console.error("Failed to fetch brands:", error);
      message.error("Failed to fetch brands. Please try again.");
    } finally {
      setLoading(false)
    }
  };

  useEffect(() => {
    fetchBrands();
  }, [paginationInfo.current, paginationInfo.pageSize, searchQuery]);

  // Handle pagination changes
  const handlePaginationChange = (current, pageSize) => {
    setPaginationInfo({ ...paginationInfo, current, pageSize });
  };

  // Add brand
  const handleAddBrand = async (newBrand) => {
    try {
      await API.post("/brands", newBrand);
      message.success("Brand added successfully!");
      fetchBrands();
    } catch (error) {
      console.error("Error adding brand:", error);
      message.error(error.response?.data?.message || "Error when adding brand.");
    }
  };

  // Edit brand
  const handleEditBrand = async (updatedBrand) => {
    try {
      await API.put(`/brands/${updatedBrand._id}`, updatedBrand);
      message.success("Brand updated successfully!");
      fetchBrands();
      setOpenDrawer(false);
    } catch (error) {
      console.error("Error editing brand:", error);
      message.error(error.response?.data?.message || "Error when updating brand.");
    }
  };

  // Delete brand
  const handleDeleteBrand = async () => {
    try {
      await API.delete(`/brands/${brandToDelete._id}`);
      message.success("Brand deleted successfully!");
      fetchBrands();
    } catch (error) {
      console.error("Error deleting brand:", error);
      message.error(error.response?.data?.message || "Error when deleting brand.");
    } finally {
      setIsDeleteModalVisible(false);
    }
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setPaginationInfo((prev) => ({ ...prev, currentPage: 1 }));
  };

  const columns = [
    {
      title: "Index",
      key: "index",
      render: (_, __, index) =>
        (paginationInfo.current - 1) * paginationInfo.pageSize + index + 1,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    userRole.editPermission == true &&{
      
      
      title: "Actions",
      key: "actions",
      align: "center",
      render: (record) => (
        <>
          <Button
            icon={<EditOutlined />}
            onClick={() => {
              setIsEdit(true);
              setSelectedBrand(record);
              setOpenDrawer(true);
            }}
          />
          {/* <Button
            danger
            icon={<DeleteOutlined />}
            style={{ marginLeft: 8 }}
            onClick={() => {
              setBrandToDelete(record);
              setIsDeleteModalVisible(true);
            }}
          /> */}
        </>
      ),
    },
  ];

  return (
    <div  style={{
      padding: "20px",
      background: "#fff",
      borderRadius: "8px",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
    }}>
      <Row
        gutter={[16, 16]}
        style={{
          marginBottom: 16,
          padding: '0 20px',
          justifyContent: 'flex-end',
        }}
      >
        <Col xs={24} sm={24} md={12} lg={12}>
          <Space
            style={{
              width: '100%',
              justifyContent: 'flex-end',
              flexWrap: 'wrap',
              gap: '10px',
            }}
          >
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => {
                setIsEdit(false);
                setSelectedBrand(null);
                setOpenDrawer(true);
              }}
              style={{
                flex: '0 1 auto',
                maxWidth: '150px',
              }}
            >
              Add New
            </Button>
            <Input
              placeholder="Search Brands"
              prefix={<SearchOutlined />}
              value={searchQuery}
              onChange={handleSearch}
              style={{
                flex: '1 1 auto',
                minWidth: '150px',
                maxWidth: '300px',
              }}
            />
          </Space>
        </Col>
      </Row>


      <CustomTable
        columns={columns}
        dataSource={brands} // Ensure the filtered data is passed here
        onPaginationChange={(pagination) => {
          setPaginationInfo({
            current: pagination.current,
            pageSize: pagination.pageSize,
          });
        }}
        loading={loading}
        style={{ padding: '0 20px' }}
        total={paginationInfo.total}
      />

      <BrandDrawer
        open={openDrawer}
        setOpen={setOpenDrawer}
        data={selectedBrand}
        isEdit={isEdit}
        onSubmit={isEdit ? handleEditBrand : handleAddBrand}
      />

      <ConfirmationModal
        visible={isDeleteModalVisible}
        onConfirm={handleDeleteBrand}
        onCancel={() => setIsDeleteModalVisible(false)}
        title="Confirm Deletion"
        content="Are you sure you want to delete this brand? This action cannot be undone."
      />
    </div>

  );
}
